import { useEffect, useState } from 'react';

import { observer } from 'mobx-react-lite';
import ListDivider from '@mui/joy/ListDivider';
import ListItem from '@mui/joy/ListItem';
import ListItemButton from '@mui/joy/ListItemButton';
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';
import Box from '@mui/joy/Box';
import Tooltip from '@mui/joy/Tooltip';
import Chip from '@mui/joy/Chip';

import Link from 'components/Link';
import Date from 'components/Date';
import IdentityAvatar  from 'components/IdentityAvatar';
import { CollaboratorsProps } from "stores/collaborators_store";
import { CollabProps } from "stores/collab_store";
import useCollabs from 'hooks/useCollabs';
import useUserIdentity from 'hooks/useUserIdentity';


export function CollabTitle({collab}:{collab:CollabProps|null|undefined}) {
    return (
        <Typography
            level="title-lg">
            {collab ? collab.title : <em>Loading</em>}
        </Typography>
    );
}

export const CollaboratorListItemContent = observer(({ collaborator }: { collaborator: CollaboratorsProps }) => {
    const { getCollab } = useCollabs();
    const collab = getCollab(collaborator?.collab);
    return (
        <ListItem>
            <ListItemButton
                    sx={(theme) => ({
                        backgroundColor: `${theme.vars.palette.background.surface}`,
                        padding: 1,
                        flexDirection: 'column',
                        alignItems: 'initial',
                        gap: 1,
                        fontWeight: 'normal',
                    })}


            >

                <Stack spacing={1}>
                    <IdentityAvatar
                        interactive="link"
                        size="chip"
                        identityKey={collab?.identity} />
                    <CollabTitle collab={collab || null} />
                </Stack>

                <Stack
                    alignItems="center"
                    direction="row"
                    spacing={1}
                    sx={{ width: "100%" }}
                >
                    <Tooltip arrow
                        title="Collabs use minutes.">
                        <Chip size="sm">
                            Collab
                        </Chip>
                    </Tooltip>

                    <Box flexGrow={1} />
                    <Typography level="body-xs">
                        <Date dateString={collaborator.date_created} />
                    </Typography>
                </Stack>

            </ListItemButton>
        </ListItem>
    );
});


const CollaboratorListItem = observer(({collaborator} : { collaborator: CollaboratorsProps }) => {
    const { fetchCollab } = useCollabs();
    const [fetched, setFetched] = useState(false);
    const { currentIdentity } = useUserIdentity();
    useEffect(() => {
        if(collaborator?.collab) {
            if(fetchCollab && !fetched) {
                setFetched(true);
                fetchCollab(currentIdentity.key, collaborator.collab);
            }
        }
    }, [fetchCollab, collaborator.collab, fetched, setFetched, currentIdentity.key]);

    return (
        <>
            <Link underline="none" to={`/collab/${collaborator.collab}`}>
                <CollaboratorListItemContent collaborator={collaborator} />
            </Link>
            <ListDivider sx={{ margin: 0 }} />
        </>


    );
});

export default CollaboratorListItem;
